import axios from 'axios';
import { FETCH_USER, WAITING, ERROR } from './types';

export const fetchUser = () => async dispatch => {
	dispatch({ type: WAITING, payload: true });
	const res = await axios.get('/api/current_user');
	dispatch({ type: FETCH_USER, payload: res.data });
	dispatch({ type: WAITING, payload: false });

	return true;
};

export const registerUser = (user, history) => async dispatch => {
	dispatch({ type: ERROR, payload: false });
	const res = await axios.post('/api/register', user);

	if (res.status === 209) {
		const { message } = res.data;
		return dispatch({ type: ERROR, payload: message });
	}

	history.push('/login');
	dispatch({
		type: ERROR,
		payload: `You may now log in.`
	});
	return dispatch({ type: FETCH_USER, payload: res.data });
};

export const loginUser = user => async dispatch => {
	dispatch({ type: ERROR, payload: false });
	const res = await axios.post('/api/login', user);
	if (res.status === 209) {
		console.log(res.data);
		const { message } = res.data;
		return dispatch({ type: ERROR, payload: message });
	}

	const root = `${window.location.protocol}//${window.location.host}`;
	return (window.location.href = root);
};



// WEBPACK FOOTER //
// ./src/actions/index.js